<script setup lang="ts">
import { isFeatureToggleActive } from '@libs/feature-toggle';

import { HotelSelectionViewType } from '../models';
import { useHotelSelectionStore } from '../stores';

import HotelSelectionList from './HotelSelectionList.vue';
import HotelSelectionListLoader from './HotelSelectionListLoader.vue';
import HotelSelectionMap from './HotelSelectionMap.vue';

const hotelSelectionStore = useHotelSelectionStore();

interface HotelSelectionContentMobileEmits {
  (eventName: 'initialized-hotel-selection-list'): void;
}

const emit = defineEmits<HotelSelectionContentMobileEmits>();
</script>

<template>
  <div class="hotel-selection-content-mobile">
    <div
      v-if="hotelSelectionStore.viewType === HotelSelectionViewType.List"
      class="list-wrapper"
    >
      <HotelSelectionListLoader
        v-if="
          hotelSelectionStore.shouldDisplayLoader ||
          isFeatureToggleActive('loader')
        "
      />
      <HotelSelectionList
        v-else
        :data="hotelSelectionStore.hotelSelectionCards"
        is-mobile
        @initialized-hotel-selection-list="
          emit('initialized-hotel-selection-list')
        "
      />
    </div>
    <HotelSelectionMap
      v-else-if="hotelSelectionStore.viewType === HotelSelectionViewType.Map"
    />
  </div>
</template>

<style scoped lang="scss">
.hotel-selection-content-mobile {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);

  height: 100%;

  background-color: var(--color-off-white);

  .list-wrapper {
    padding-top: var(--spacing-12);
  }
}
</style>
